import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Convenio} from '../_models/convenio';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {CreditoConcepto} from '../_models/credito-concepto';
import {ConvenioPlanCargo} from '../_models/convenio-plan-cargo';

@Injectable({
  providedIn: 'root'
})
export class ConveniosConceptosService {

  private rutServicio = AppSettings.rutServiciosAPL + '/api/conveniosConceptos/';


  constructor( private httpClient: HttpClient, private autServicio: AutenticacionService  ) { }

  listado() {
    return this.httpClient.get( this.rutServicio ).pipe( map( res => res as ConvenioPlanCargo[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httpClient.get( this.rutServicio + id ).pipe( map( res => res as ConvenioPlanCargo ) );
  }

  listadoHabilitados() {
    return this.httpClient.get( this.rutServicio + 'enabled' ).pipe( map( res => res as ConvenioPlanCargo[] ) );
  }

  crear( regCrear: ConvenioPlanCargo ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ConvenioPlanCargo ) );
  }

  actualizar( regActualizar: ConvenioPlanCargo ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  buscarDobleRegistro( codigo: string ) {
    return this.httpClient.post( this.rutServicio + 'findCodigo', codigo ).pipe( map( res => res as any ) );
  }
}
